import styled from 'styled-components'

import { Text, Colors, Spacing, StackChildren } from '@doordash/design-language'

type WidthProps = {
  width?: string
}

interface IMobileProps extends WidthProps {
  mobile: boolean
}

export const UnorderedList = styled.ul`
  color: ${Colors.SystemGrey60};
`

export const SignupFormContainer = styled.div`
  display: flex;
  padding: ${Spacing.Large}px;
  justify-content: flex-end;
`

export const DescriptionContainer = styled.div`
  width: ${(props: IMobileProps) => (props.mobile ? '100vw' : '95vw')};
  border: 1px solid ${Colors.SystemTeal50};
  margin: ${Spacing.Large}px;
`

export const ContentContainer = styled(StackChildren)`
  padding: ${(props: IMobileProps) =>
    props.mobile ? `${Spacing.Large}px` : `${Spacing.XxxLarge}px`};
  padding-right: ${Spacing.Medium}px;
  width: ${(props: IMobileProps) => (props.width ? props.width : 'auto')};
`

export const ImageColumn = styled.div`
  width: ${(props: WidthProps) => (props.width ? props.width : 'auto')};
`

export const SectionTitle = styled(Text)``

export const SectionContent = styled(Text)``

export const SectionImage = styled.img`
  width: ${(props: IMobileProps) => (props.mobile ? '100%' : 'auto')};
  ${(props: IMobileProps) => {
    if (props.mobile) {
      return `height: auto`
    }
    return `max-width: 100%`
  }}
`
